"use strict";

exports.__esModule = true;
exports.DeviceTimelineColorController = DeviceTimelineColorController;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _DeviceColorSource = require("./DeviceColorSource");
var _PlantStateActivities = require("../../PlantStateActivities");
var _DeviceCycleColorSource = require("./DeviceCycleColorSource");
var _DeviceMetricColorSource = require("./DeviceMetricColorSource");
var _Metrics = require("../../../Catalogs/Metrics");
var _modernDocumentColor = require("../../Theme/UiDesign/modernDocumentColor");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DeviceTimelineColorController(props) {
  var getLabel = props.getLabel,
    backgroundColorSource = props.backgroundColorSource,
    deviceUuid = props.deviceUuid,
    _props$defaultColor = props.defaultColor,
    defaultColor = _props$defaultColor === void 0 ? "transparent" : _props$defaultColor,
    children = props.children;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  if (!backgroundColorSource) {
    return children({
      backgroundColor: function backgroundColor() {
        return defaultColor;
      }
    });
  }
  if (backgroundColorSource.name === "rawValue") {
    var getColor = function getColor(val) {
      var backgroundColorValueTuples = backgroundColorSource.backgroundColorValueTuples;
      if (backgroundColorValueTuples) {
        var tuple = backgroundColorValueTuples.find(function (tuple) {
          return (0, _DeviceColorSource.toStringLowerCase)(tuple.value) === (0, _DeviceColorSource.toStringLowerCase)(val);
        });
        return tuple ? (0, _modernDocumentColor.modernizeDocumentColor)(theme, tuple.color) : defaultColor;
      }
      return defaultColor;
    };
    return children({
      backgroundColor: function backgroundColor(doc) {
        var val = getLabel(doc);
        return getColor(val);
      }
    });
  }
  if (backgroundColorSource.name === "plantState") {
    return children({
      backgroundColor: function backgroundColor(doc) {
        return (0, _PlantStateActivities.getPlantStateColor)(theme, doc.dimensions.state);
      }
    });
  }
  if (backgroundColorSource.name === "custom") {
    return children({
      backgroundColor: function backgroundColor() {
        return (0, _modernDocumentColor.modernizeDocumentColor)(theme, props.backgroundColorSource.customColor);
      }
    });
  }
  if (backgroundColorSource.type === "timeseries") {
    return /*#__PURE__*/_react["default"].createElement(_DeviceCycleColorSource.DeviceCycleColorSource, {
      deviceUuid: deviceUuid,
      thresholds: backgroundColorSource.thresholds,
      defaultColor: defaultColor
    }, function (color) {
      return children({
        backgroundColor: function backgroundColor() {
          return color;
        }
      });
    });
  }
  if (backgroundColorSource.type === "metric") {
    return /*#__PURE__*/_react["default"].createElement(_DeviceMetricColorSource.DeviceMetricColorSource, {
      realtime: true,
      deviceUuid: deviceUuid,
      thresholds: (0, _modernDocumentColor.modernizeThresholds)(theme, backgroundColorSource.thresholds),
      metric: (0, _Metrics.getMetricDefinition)(backgroundColorSource.name),
      defaultColor: defaultColor
    }, function (color) {
      return children({
        backgroundColor: function backgroundColor() {
          return color;
        }
      });
    });
  }
  return children({
    backgroundColor: function backgroundColor() {
      return defaultColor;
    }
  });
}